<template>
    <div>
        <Navigation/>
        <ProfileHeader/>
    </div>
</template>
<script>
import Navigation from './Navigation.vue';
import ProfileHeader from './ProfileHeader.vue';
export default {
   components:{
    Navigation,
    ProfileHeader
   }
}
</script>
<style scoped>

</style>